export default "__VITE_ASSET__Bn8BkTsV__"